/**
 * Move an item in a list by stable `id`. Used by setlist / guest-list drag-and-drop.
 */
export function reorderListById(items, activeId, overId) {
  const list = Array.isArray(items) ? items : [];
  if (!activeId || !overId || activeId === overId) return list;
  const from = list.findIndex((item) => item && item.id === activeId);
  const to = list.findIndex((item) => item && item.id === overId);
  if (from < 0 || to < 0 || from === to) return list;
  const next = list.slice();
  const [moved] = next.splice(from, 1);
  next.splice(to, 0, moved);
  return next;
}
